<p-toast></p-toast>
<div class="container-fluid container-fullw">
  <div class="p-fluid p-grid">
    <div class="p-col-12">
      <div>
        <p-fieldset [toggleable]="true">
          <ng-template pTemplate="header">
            <span *ngIf="classDuration.id === null">{{ 'NEWCLASSDURATION' | translate }}</span>
            <span *ngIf="classDuration.id !== null">{{ 'EDITCLASSDURATION' | translate }}</span>
          </ng-template>
          <form pFocusTrap name="classDurationForm" id="classDurationForm" novalidate (ngSubmit)="submitForm(true)" [formGroup]="classDurationForm" >
            <input type="hidden" name="id" id="classDurationId" formControlName="id" />
            <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-tag"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="classDurationName" formControlName="name" type="text" pInputText [required]="true"> 
                      <label for="classDurationName" class="req">{{ 'NAME' | translate }}</label>
                    </span>
                  </div>
                </div>
                <div *ngIf="classDurationForm.controls['name'].invalid && (classDurationForm.controls['name'].dirty || classDurationForm.controls['name'].touched)" class="alert alert-danger">
                  <ng-container *ngIf="classDurationForm.controls['name'].errors !== null">
                  <div *ngIf="classDurationForm.controls['name'].errors.required">
                   {{ 'NAMEREQUIRED' | translate }}.
                  </div>
                  </ng-container>
                </div>

              </div><!--/p-col-6-->
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-marker-alt"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="classDurationNameAr" formControlName="nameAr" type="text" pInputText [required]="false"> 
                      <label for="classDurationNameAr" class="">{{ 'NAMEAR' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div><!--/p-col-6-->
            </div><!--/p-fluid p-grid-->
            <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-marker-alt"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="classDurationNameFr" formControlName="nameFr" type="text" pInputText [required]="false"> 
                      <label for="classDurationNameFr" class="">{{ 'NAMEFR' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div><!--/p-col-6-->
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-timer"></i>
                    </span>
                    <span class="p-float-label">
                      <p-inputNumber inputId="classDurationDuration" formControlName="duration" [step]="1" [showButtons]="true" [required]="true"></p-inputNumber>
                      <label for="classDurationDuration" class="req">{{ 'DURATION' | translate }}</label>
                    </span>
                  </div>
                </div>
                <div *ngIf="classDurationForm.controls['duration'].invalid && (classDurationForm.controls['duration'].dirty || classDurationForm.controls['duration'].touched)" class="alert alert-danger">
                  <ng-container *ngIf="classDurationForm.controls['duration'].errors !== null">
                  <div *ngIf="classDurationForm.controls['duration'].errors.required">
                   {{ 'DURATIONREQUIRED' | translate }}.
                  </div>
                  </ng-container>
                </div>

              </div><!--/p-col-6-->
            </div><!--/p-fluid p-grid-->
            <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="fas fa-icons "></i>
                    </span>
                    <span class="p-float-label">
                      <input id="classDurationIcon" formControlName="icon" type="text" pInputText [required]="false"> 
                      <label for="classDurationIcon" class="">{{ 'ICON' | translate }}</label>
                    </span>
                    <button type="button" pButton pRipple icon="pi pi-folder" styleClass="p-button-info" (click)="openFilerDialog('icon')"></button> 
                  </div>
                </div>

              </div><!--/p-col-6-->
              <div class="p-col-6">

                <div class="p-field p-col-12">
                    <p-toggleButton inputId="classDurationIsPublished" formControlName="isPublished" onIcon="pi pi-check" offIcon="pi pi-times"  [style]="{'width': '2em'}"></p-toggleButton>
                    <label for="classDurationIsPublished" class="p-d-inline-block p-ml-2 req">{{ 'ISPUBLISHED' | translate }}</label>
                </div>
                <div *ngIf="classDurationForm.controls['isPublished'].invalid && (classDurationForm.controls['isPublished'].dirty || classDurationForm.controls['isPublished'].touched)" class="alert alert-danger">
                  <ng-container *ngIf="classDurationForm.controls['isPublished'].errors !== null">
                  <div *ngIf="classDurationForm.controls['isPublished'].errors.required">
                   {{ 'ISPUBLISHEDREQUIRED' | translate }}.
                  </div>
                  </ng-container>
                </div>

              </div><!--/p-col-6-->
            </div><!--/p-fluid p-grid-->

            <div class="p-fluid p-grid">
              <div class="p-col-4">
                <button (click)="list()" class="btn btn-primary pull-left">
                  <i class="icon-layout-list-thumb"></i>
                  <span class="p-ml-1">{{ 'BACKCLASSDURATIONS' | translate }}</span>
                </button>
              </div>
              <div class="p-col-4 text-center">
                <button *ngIf="classDuration.id !== null" type="button" (click)="submitForm(false)" class="btn btn-primary" [disabled]="!classDurationForm.valid || disableSubmit"> <!--  [disabled]="classDurationForm.$invalid" -->
                  <i class="fas fa-spinner fa-spin" *ngIf="disableSubmit && !redirect"></i>
                  <i class="fas fa-check-circle" *ngIf="!(disableSubmit && !redirect)"></i>
                  <span class="p-ml-1"> {{ 'APPLY' | translate }}</span>
                </button>
              </div>
              <div class="p-col-4">
                <button type="button" (click)="submitForm(true)" class="btn btn-primary pull-right" [disabled]="disableSubmit"> <!--  [disabled]="!classDurationForm.valid || " -->
                  <i class="fas fa-spinner fa-spin" *ngIf="disableSubmit && redirect"></i>
                  <i class="icon-save" *ngIf="!(disableSubmit && redirect)"></i>
                  <span class="p-ml-1">{{ 'SAVE' | translate }}</span>
                </button>
              </div>
            </div>
          </form>
        </p-fieldset>
        <div class="p-fluid p-grid">
          <div class="col-sm-12 p-col-4 mb-2">
          </div>
          <div class="col-sm-12 p-col-4 mb-2 text-center">
          </div>
          <div class="col-sm-12 p-col-4 mb-2">
          </div>
        </div>
      </div>
    </div><!--/p-col-12-->
  </div><!--/p-fluid p-grid-->
  <p-scrollTop target="parent"></p-scrollTop>
</div><!--/container-fluid container-fullw-->
<!-- end: FORM -->

